// extracted by mini-css-extract-plugin
export default {"addressWrapper":"CompanyDetails_addressWrapper__wVnzi"};